/* eslint-disable */
import React from "react";

const FormTitle = ({ id, label, type, placeholder, value, error, onChange, prepend, source, classNameLabel, inputRequired }) => {

  return (
    <div className={`${source === 'login' ? 'input-auth-login' : 'input-auth'}`}>
      <label className={`${classNameLabel ? classNameLabel : 'cl-neutal600 fsize-14 fweight-500'} form-label`}>{label} {inputRequired && <span className="cl-primary">*</span>}</label>
      <div className="input-group">
        {prepend !== undefined || prepend !== "" ? (
          <div className={`input-group-prepend ${prepend ? 'border-right' : 'd-none'}`}>
            <span className={`input-group-text ${prepend ? 'border-right' : 'd-none'}`} id="inputGroupPrepend">
              {prepend}
            </span>
          </div>
        ) : ""}
        <input
          type={type}
          className={`form-control cl-neutral-700 fsize-12 fweight-500 ${prepend && "border-left"} ${!error?.isValid && "has-error"}`}
          id={id}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
      {!error?.isValid && <div className="text-danger text-error">{error?.msg}</div>}
    </div>
  );
};

export default FormTitle;
